import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, P, Loading,
} from 'konsys-ui'
import { CREATE_DRIVER, UPDATE_DRIVER } from '../../../constants/graphql/mutation'
import detailType from '../util-functions'
import { detailMode } from '../constants'
import { DRIVER_INFO, GET_TRUCK_LIST } from '../../../constants/graphql/query'
import { ActionBar, DriverLog } from '../../../components/driver-components'
import { formatDateRange } from '../../../utils/util-services'

const mockLeaveData = [
  {
    id: 1,
    startDate: '2025-08-24',
    endDate: '2025-08-25',
    leaveReason: 'ลากิจ',
  },
  {
    id: 2,
    startDate: '2025-08-26',
    endDate: '2025-08-29',
    leaveReason: 'ลากิจ',
  },
  {
    id: 3,
    startDate: '2025-08-28',
    endDate: '2025-08-28',
    leaveReason: 'ลากิจ',
  },
  {
    id: 4,
    startDate: '2025-08-30',
    endDate: '2025-08-31',
    leaveReason: 'ลากิจ',
  },
]

// HistoryRow component
const LeaveRow = ({ item }) => (
  <div className="grid grid-cols-8 gap-4 px-4 py-4 border-b border-gray-200 bg-white my-2 rounded-sm">
    <div className="col-span-2 text-base font-semibold">
      <p className="text-black">{formatDateRange(item.startDate, item.endDate)}</p>
    </div>
    <div className="col-span-2 text-black text-base">
      {item.startDate && item.endDate
        ? `${Math.ceil(
            (new Date(item.endDate) - new Date(item.startDate)) / (1000 * 60 * 60 * 24) + 1,
          )} วัน`
        : '-'}
    </div>
    <div className="col-span-4 text-black text-base">{item.remark}</div>
  </div>
)

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW

  const [mutationVariables, setMutationVariables] = useState()

  let onChangeHandler = (id, value) => {
    setMutationVariables({
      ...mutationVariables,
      [id]: id === 'salary' ? parseFloat(value, 10) : value,
    })
  }

  let plateNumList = []

  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      <Query
        query={GET_TRUCK_LIST}
      >
        {
          ({ data: truck, error: truckError, loading: truckLoading }) => {
            if (isAddMode && truckLoading && _.isEmpty(truck)) return <Loading center='true' />
            return (
              <Div>
                {
                  isAddMode
                    ? detailType(props.match.params, plateNumList, onChangeHandler)
                    : <Query
                    query={DRIVER_INFO}
                    variables={{ id: props.match.params.id }}
                  >{({ data, error, loading }) => {
                    if ((loading && _.isEmpty(data)) || (truckLoading && _.isEmpty(truck))) return <Loading center='true' />
                    if (error || truckError) return <P>เกิดข้อผิดพลาด</P>
                    plateNumList = _.map(truck.TruckList.lists, v => v.plateNumber)
                    onChangeHandler = (id, value) => {
                      setMutationVariables({
                        employeeId: data.DriverInfo.driver.employeeId,
                        fullname: data.DriverInfo.driver.fullname,
                        fleetCode: data.DriverInfo.driver.fleetCode,
                        licenseId: data.DriverInfo.driver.licenseId,
                        licenseExpire: data.DriverInfo.driver.licenseExpire,
                        startDate: data.DriverInfo.driver.startDate,
                        salary: data.DriverInfo.driver.salary,
                        companyType: data.DriverInfo.driver.companyType,
                        ...mutationVariables,
                        [id]: id === 'employeeId' ? parseInt(value, 10) : id === 'salary' ? parseFloat(value, 10) : value,
                      })
                    }
                    return <Div>
                      {detailType(props.match.params, plateNumList, onChangeHandler, data.DriverInfo.driver)}
                      {!_.isEmpty(data.DriverInfo.driver.logs) && <DriverLog data={data.DriverInfo.driver.logs}/>}
                      <div className="flex flex-col font-inter my-6">
                        {/* Header Section */}
                        <div className="mb-4 flex justify-between items-center">
                          <p className="text-xl font-semibold font-inter">
                          รายละเอียดการลาที่กำลังจะมาถึง
                          </p>
                        </div>

                        {/* History List */}
                        <div className="pb-10">
                          {/* Header Row */}
                          <div className="grid grid-cols-8 gap-4 px-4 py-3 font-bold text-gray-700">
                            <div className="col-span-2 text-lg text-gray-500 font-semibold">วันที่เริ่ม และ สิ้นสุดการลา</div>
                            <div className="col-span-2 text-lg text-gray-500 font-semibold">รวมวันลา</div>
                            <div className="col-span-4 text-lg text-gray-500 font-semibold">หมายเหตุการลา</div>
                          </div>
                          {(data?.DriverInfo.driver.upcomingLeave || []).map(item => (
                            <LeaveRow key={item.batchId} item={item} />
                          ))}
                        </div>
                      </div>
                    </Div>
                  }}
                  </Query>
                }
              </Div>
            )
          }
        }
      </Query>
      {/* ================== Footer section ================== */}
      {
        !isViewMode
          ? <Mutation
              mutation={isAddMode ? CREATE_DRIVER : UPDATE_DRIVER}
            >{(doAction, { loading }) => (
              <ActionBar
                loading={loading}
                disabled={_.isUndefined(mutationVariables)
                  || _.isUndefined(mutationVariables.fullname) || _.isEmpty(mutationVariables.fullname)
                  || _.isUndefined(mutationVariables.fleetCode) || _.isEmpty(mutationVariables.fleetCode)
                  || _.isUndefined(mutationVariables.licenseId) || _.isEmpty(mutationVariables.licenseId)
                  || _.isUndefined(mutationVariables.salary) || _.isNaN(mutationVariables.salary)
                  || _.isUndefined(mutationVariables.companyType)
                  || _.isUndefined(mutationVariables.licenseExpire) || mutationVariables.licenseExpire === 'Invalid date'
                  || _.isUndefined(mutationVariables.startDate) || mutationVariables.startDate === 'Invalid date'}
                isAddMode={isAddMode}
                isViewMode={isViewMode}
                doAction={doAction}
                mutationVariables={{ ...mutationVariables }}
                props={props}
              />
            )}
            </Mutation>
          : <ActionBar
              isAddMode={isAddMode}
              isViewMode={isViewMode}
              props={props}
            />
      }
    </Div>
  )
}

export default Index
export { Index }
